import axios,{AxiosResponse,AxiosStatic} from "axios";

export default class Translate{
    protected axios: AxiosStatic;

    constructor() {
        this.axios = axios;
    }

    /**
     * @param message
     */
    public get(message: string): Promise<AxiosResponse>{
        const url = String(process.env.VUE_APP_GOOGLE_TRANSLATE_URL);
        return this.axios.get(url + '?text=' + message + '&source=en&target=ja');
    }
}